const initialState = {
  sideBarCalculatorShown: false,
};

export const uiReducer = (state = initialState, action = null) => {
  switch (action.type) {
    case "SHOW_SIDEBAR_CALCULATOR":
      return {
        ...state,
        sideBarCalculatorShown: action.payload,
      };
    case "TOGGLE_SIDEBAR_CALCULATOR":
      return {
        ...state,
        sideBarCalculatorShown: !state.sideBarCalculatorShown,
      };
    default:
      return state;
  }
};
